// InviteUserForm.js
import React, { useState } from 'react';
import axios from '../../api/axiosConfig';
import { FaUserPlus } from 'react-icons/fa';

function InviteUserForm({ board }) {
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleInvite = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`/boards/${board.id}/invite-email`, { email });
      setMessage('Einladung gesendet!');
      setEmail('');
      setTimeout(() => {
        setShowModal(false);
        setMessage('');
      }, 1500);
    } catch (err) {
      console.error(err);
      setMessage('Fehler beim Senden der Einladung.');
    }
  };

  return (
    <>
      <button className="btn btn-secondary invite-button" onClick={() => setShowModal(true)}>
        <FaUserPlus />
        User einladen
      </button>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal" role="dialog" aria-modal="true" aria-labelledby="invite-title">
            <h3 id="invite-title">User einladen</h3>
            <form onSubmit={handleInvite}>
              <input
                type="email"
                className="input"
                placeholder="E-Mail Adresse"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
              <div className="modal-buttons">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Abbrechen
                </button>
                <button type="submit" className="btn">Einladen</button>
              </div>
            </form>
            {message && <p className="modal-message" role="status">{message}</p>}
          </div>
        </div>
      )}
    </>
  );
}

export default InviteUserForm;
